var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"text","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.countdown > 0 ? ("" + _vm.disabledText) : _vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }